(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function(){
        iniciarApp();
    });

    function iniciarApp() {
                    
        // iniciarCarrusel();    
        
        iniciaSlider();

    }

    function iniciaSlider() {
        // SLIDER DE LOS MÓDULOS DEL SISTEMA

        $(".slideElements").jdSlider({
            wrap: '.slide-inner',
            slideShow: 4,
            slideToScroll: 1,
            isLoop: false,
            responsive: [{ 
                viewSize: 576,
                settings: {
                    slideShow: 1,
                    slideToScroll: 1
                }
            },{
                viewSize: 768,
                settings: {
                    slideShow: 2,
                    slideToScroll: 2
                }
            },{
                viewSize: 1024,
                settings: {
                    slideShow: 3,
                    slideToScroll: 3
                }
            }]
        
        });        

    }

    // function iniciarCarrusel() {
    //     const textElement = document.querySelector('.text-carrusel');
    //     const textWidth = textElement.offsetWidth;
    //     const screenWidth = window.innerWidth;
    //     const duration = (textWidth + screenWidth) / 200;
  
    //     textElement.style.animationDuration = duration + 's';
    //   }
  

        
})();